/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import reportId from './report-id';
import step from './step';

export default combineReducers({
	step,
	reportId,
});
